import {
  catalogPreview,
  heroFull,
  comparison01SourcePreview,
  comparison01SourceFull,
  comparison01ResultPreview,
  comparison01ResultFull,
  comparison02SourcePreview,
  comparison02SourceFull,
  comparison02ResultPreview,
  comparison02ResultFull,
  comparison03SourcePreview,
  comparison03SourceFull,
  comparison03ResultPreview,
  comparison03ResultFull,
  comparison04SourcePreview,
  comparison04SourceFull,
  comparison04ResultPreview,
  comparison04ResultFull,
  result01Full,
  result02Full,
  result03Full,
  result04Full,
  result05Full,
  result06Full,
  result07Full,
} from './assets';

const image = (asset, alt) => ({
  preview: asset,
  full: asset,
  alt,
});

const projectImages = {
  catalog: {
    preview: catalogPreview,
    full: catalogPreview,
    alt: 'Обмерная 2D-документация отдельно стоящего ресторана',
  },
  hero: {
    preview: heroFull,
    full: heroFull,
    alt: 'Облако точек существующего отдельно стоящего ресторана',
  },
};

const comparisonItems = [
  {
    id: 'comparison-01',
    title: 'Фрагмент плана этажа',
    description:
      'Фактическая геометрия стен, проёмов и функциональных зон перенесена из облака точек в точный обмерный план.',
    source: {
      preview: comparison01SourcePreview,
      full: comparison01SourceFull,
      alt: 'Фрагмент облака точек с геометрией стен и проёмов первого этажа',
      label: 'Point Cloud',
    },
    result: {
      preview: comparison01ResultPreview,
      full: comparison01ResultFull,
      alt: 'Фрагмент обмерного 2D-плана этажа со стенами и проёмами',
      label: '2D-документация',
    },
  },
  {
    id: 'comparison-02',
    title: 'Фрагмент плана потолка',
    description:
      'Потолочные плоскости, светильники, решётки и другие видимые элементы зафиксированы по данным сканирования.',
    source: {
      preview: comparison02SourcePreview,
      full: comparison02SourceFull,
      alt: 'Фрагмент облака точек с потолочными плоскостями и видимыми элементами',
      label: 'Point Cloud',
    },
    result: {
      preview: comparison02ResultPreview,
      full: comparison02ResultFull,
      alt: 'Фрагмент обмерного 2D-плана потолка со светильниками и решётками',
      label: '2D-документация',
    },
  },
  {
    id: 'comparison-03',
    title: 'Фрагмент плана кровли',
    description:
      'Контуры кровли, парапеты и кровельное оборудование перенесены в чертёж с фактическими привязками.',
    source: {
      preview: comparison03SourcePreview,
      full: comparison03SourceFull,
      alt: 'Фрагмент облака точек с контурами кровли и кровельным оборудованием',
      label: 'Point Cloud',
    },
    result: {
      preview: comparison03ResultPreview,
      full: comparison03ResultFull,
      alt: 'Фрагмент обмерного 2D-плана кровли с парапетами и оборудованием',
      label: '2D-документация',
    },
  },
  {
    id: 'comparison-04',
    title: 'Фрагмент фасада',
    description:
      'Проёмы, отделочные зоны и наружные элементы фасада восстановлены по фактической геометрии объекта.',
    source: {
      preview: comparison04SourcePreview,
      full: comparison04SourceFull,
      alt: 'Фрагмент облака точек с наружной геометрией фасада',
      label: 'Point Cloud',
    },
    result: {
      preview: comparison04ResultPreview,
      full: comparison04ResultFull,
      alt: 'Фрагмент обмерного 2D-фасада с проёмами и отделочными зонами',
      label: '2D-документация',
    },
  },
];

const resultItems = [
  {
    id: 'result-01',
    title: 'План этажа',
    description:
      'Фактическая конфигурация помещений, стен, перегородок, проёмов и основных функциональных зон.',
    preview: result01Full,
    full: result01Full,
    alt: 'Обмерный план этажа отдельно стоящего ресторана',
  },
  {
    id: 'result-02',
    title: 'План потолка',
    description:
      'Расположение потолочных плоскостей, светильников, решёток и видимого потолочного оборудования.',
    preview: result02Full,
    full: result02Full,
    alt: 'Обмерный план потолка со светильниками и видимым оборудованием',
  },
  {
    id: 'result-03',
    title: 'План кровли',
    description:
      'Контуры кровли, парапеты, отметки и размещение существующего кровельного оборудования.',
    preview: result03Full,
    full: result03Full,
    alt: 'Обмерный план кровли с парапетами и существующим оборудованием',
  },
  {
    id: 'result-04',
    title: 'План оборудования',
    description:
      'Размещение стационарного оборудования и его привязка к фактической геометрии помещений.',
    preview: result04Full,
    full: result04Full,
    alt: 'Обмерный план размещения стационарного оборудования',
  },
  {
    id: 'result-05',
    title: 'Фасады — Front / Non-Drive-Thru',
    description:
      'Главный фасад и боковая сторона здания с фактическими проёмами, высотами и наружными элементами.',
    preview: result05Full,
    full: result05Full,
    alt: 'Обмерные чертежи главного фасада и боковой стороны здания',
  },
  {
    id: 'result-06',
    title: 'Фасады — Rear / Drive-Thru Side',
    description:
      'Задний фасад и сторона проезда с существующими проёмами, оборудованием и архитектурными элементами.',
    preview: result06Full,
    full: result06Full,
    alt: 'Обмерные чертежи заднего фасада и стороны проезда',
  },
  {
    id: 'result-07',
    title: 'Генеральный план',
    description:
      'Расположение здания, проездов, площадок и основных элементов участка площадью около 2 460 м².',
    preview: result07Full,
    full: result07Full,
    alt: 'Генеральный план здания, проездов и участка площадью около 2 460 квадратных метров',
  },
];

const project01 = {
  id: '1',
  slug: 'project-01',
  template: 'project-01',
  images: projectImages,
  type: { id: '2d-documentation', label: '2D-документация' },
  catalog: {
    index: '01',
    title: '2D-документация ресторана',
    description:
      'Комплект As-Built 2D-чертежей здания и участка по облаку точек. Документация подготовлена для дальнейшей модернизации.',
    tags: ['2D CAD', 'DWG', 'As-Built'],
    skills: '2D-документация, DWG, Scan-to-CAD',
    image: projectImages.catalog,
    ctaLabel: 'Смотреть кейс',
  },
  hero: {
    backLabel: 'Назад к проектам',
    title: '2D-документация ресторана по облаку точек',
    titleLines: ['2D-документация ресторана', 'по облаку точек'],
    description:
      'Комплект As-Built чертежей здания и участка для модернизации — от планов этажей и потолков до фасадов, кровли, оборудования и генплана.',
    descriptionLines: [
      'Комплект As-Built чертежей здания и участка для модернизации — от планов этажей и потолков',
      'до фасадов, кровли, оборудования и генплана.',
    ],
    image: projectImages.hero,
    stats: [
      { id: 'area', value: '261,9 м²', label: 'Площадь здания' },
      { id: 'format', value: 'DWG', label: 'Формат документации' },
      { id: 'duration', value: '5 рабочих дней', label: 'Срок выполнения' },
    ],
  },
  visual: projectImages.hero,
  info: {
    equalHeight: true,
    items: [
      {
        id: 'client',
        label: 'Заказчик',
        value: 'Архитектурно-проектная команда',
      },
      { id: 'stage', label: 'Этап', value: 'Подготовка к модернизации' },
      {
        id: 'workPurpose',
        label: 'Назначение работ',
        value: 'Обмерная документация',
      },
      { id: 'year', label: 'Год постройки', value: '2005' },
    ],
  },
  about: {
    title: 'О проекте',
    bodyOnly: true,
    paragraphs: [
      'Существующий отдельно стоящий ресторан площадью 262 м² готовился к модернизации. Для разработки новых решений проектной команде требовалась достоверная информация о фактической геометрии здания, расположении оборудования и организации участка.',
      'По зарегистрированному облаку точек и материалам полевого обследования мы подготовили согласованный комплект обмерных 2D-чертежей. Документация охватила план этажа, потолок, кровлю, стационарное оборудование, фасады и участок площадью около 2 460 м².',
      'В результате заказчик получил единую As-Built основу в DWG, которую можно использовать для планирования модернизации, координации решений и сокращения повторных выездов на объект.',
    ],
  },
  sourceData: {
    title: 'Исходные данные',
    items: [
      { id: 'format', label: 'Формат облака точек', value: 'RCP / E57' },
      {
        id: 'additionalMaterials',
        label: 'Дополнительные материалы',
        value: 'Фотофиксация и отчёт обследования',
      },
      {
        id: 'coverage',
        label: 'Охват',
        value: 'Здание, фасады, кровля и участок',
      },
      {
        id: 'result',
        label: 'Требуемый результат',
        value: 'Комплект обмерных чертежей в DWG',
      },
    ],
    capturedTitle: 'Что было зафиксировано',
    capturedItems: [
      {
        id: 'structure',
        label: 'Фактическая геометрия стен, перегородок и проёмов',
      },
      {
        id: 'ceiling',
        label: 'Потолочные плоскости и видимые потолочные элементы',
      },
      {
        id: 'roof',
        label: 'Контуры кровли и расположение кровельного оборудования',
      },
      {
        id: 'facades',
        label: 'Фасады, наружные проёмы и основные архитектурные элементы',
      },
      {
        id: 'equipment',
        label: 'Стационарное оборудование и видимые точки подключения',
      },
      { id: 'site', label: 'Проезды, площадки и основные элементы участка' },
    ],
  },
  tasks: {
    title: 'Задача проекта',
    items: [
      'Преобразовать данные облака точек в понятный комплект обмерных 2D-чертежей',
      'Зафиксировать фактическую геометрию здания без выравнивания существующих отклонений',
      'Подготовить план этажа, план потолка, план кровли, план оборудования, фасады и генплан',
      'Организовать чертежи в редактируемом DWG с понятной структурой слоёв',
      'Проверить согласованность геометрии между всеми видами перед передачей заказчику',
    ],
  },
  process: {
    title: 'Процесс работы',
    items: [
      {
        id: '01',
        title: 'Подготовка исходных данных',
        text: 'Проверили покрытие облака точек, сопоставили его с материалами обследования и подготовили рабочие сечения для построения чертежей.',
      },
      {
        id: '02',
        title: 'Создание 2D-документации',
        text: 'Перенесли фактическую геометрию здания, кровли, фасадов, оборудования и участка в структурированный комплект DWG-чертежей.',
      },
      {
        id: '03',
        title: 'Контроль и выдача',
        text: 'Сверили взаимное соответствие планов и фасадов, проверили ключевые привязки и подготовили файлы к дальнейшей проектной работе.',
      },
    ],
  },
  comparisonGallery: {
    title: 'Point Cloud to 2D Documentation',
    description:
      'Четыре примера показывают, как фактическая геометрия объекта была перенесена из облака точек в чистые и пригодные для работы 2D-чертежи.',
    sourceLabel: 'Point Cloud',
    resultLabel: '2D-документация',
    modalLabel: 'Просмотр Point Cloud to 2D Documentation',
    items: comparisonItems,
  },
  resultGallery: {
    title: 'Итоговая 2D-документация',
    description:
      'Комплект обмерных чертежей отражает фактическое состояние здания и участка и служит основой для последующей модернизации.',
    modalLabel: 'Просмотр итоговой 2D-документации',
    modalEnabled: true,
    zoomEnabled: true,
    addGridSpacing: true,
    carouselEnabled: true,
    items: resultItems,
  },
  deliverables: {
    title: 'Что получил клиент',
    items: [
      'Комплект обмерных 2D-чертежей здания и участка',
      'Редактируемые DWG-файлы с организованной структурой слоёв',
      'Планы этажа, потолка, кровли и оборудования',
      'Фасады здания и генеральный план',
    ],
  },
  benefits: {
    title: 'Что это дало',
    items: [
      'Возможность начать проектирование на основе фактической геометрии',
      'Снижение риска ошибок из-за устаревших или неполных исходных чертежей',
      'Уменьшение потребности в повторных выездах и ручных обмерах',
    ],
  },
  metrics: {
    title: 'Параметры проекта',
    equalHeight: true,
    items: [
      { id: 'area', label: 'Площадь здания', value: '262 м²' },
      { id: 'volume', label: 'Объём данных (облако точек)', value: '3,08 ГБ' },
      { id: 'timeline', label: 'Срок выполнения', value: '5 рабочих дней' },
      { id: 'format', label: 'Формат', value: 'DWG' },
    ],
  },
  estimateCta: {
    eyebrow: 'Оценка по вашим данным',
    title: ['Нужно превратить облако точек', 'в рабочие чертежи?'],
    text: 'Пришлите фрагмент облака точек или техническое задание. Мы оценим состав документации, сроки и стоимость работ и предложим подходящий формат результата.',
    buttonLabel: 'Получить оценку проекта',
    href: '/contacts',
    image: image(catalogPreview, ''),
  },
  seo: {
    title: 'Обмерная 2D-документация ресторана по облаку точек | DotPolyline',
    description:
      'Кейс подготовки обмерных as-built 2D-чертежей отдельно стоящего ресторана и участка по облаку точек для последующей модернизации.',
  },
};

export default project01;
